module.exports = __webpack_public_path__ + "img/image-brainstorming.1f0ee519.svg";